export const environment = {
  production: true,
  buildId: '3837292877323531',
  configFile: 'config.json',
};
